import { get, post, put, del } from "@/services/axiosUitils";
import {
  QueryCategory,
  PaginatedResponse,
  CreateCategoryPayload,
  CreateQueryMasterPayload,
  AdvancedQueryField,
  CreateAdvancedQueryFieldPayload,
  ExecuteAdvancedQueryPayload,
  ExecuteAdvancedQueryResponse,
  UserQuery,
  SaveUserQueryPayload,
  QueryMaster,
} from "@/utils/types/Screener/Screener";

const base = "/screener/";

class ScreenerService {
  getQueryCategories = async (
    page?: number,
    pageSize?: number,
    search?: string
  ): Promise<PaginatedResponse<QueryCategory>> => {
    let url = `${base}query-category/`;
    if (page) {
      url += `?page=${page}`;
    }
    if (pageSize) {
      url += `&page_size=${pageSize}`;
    }
    if (search) {
      url += `&search=${search}`;
    }
    return await get(url);
  };

  createQueryCategory = async (
    data: CreateCategoryPayload
  ): Promise<QueryCategory> => {
    return await post(`${base}query-category/`, data);
  };

  getCategoryById = async (id: string): Promise<any> => {
    return await get(`${base}query-category/${id}/`);
  };

  updateCategoryById = async (
    id: string,
    data: CreateCategoryPayload
  ): Promise<any> => {
    return await put(`${base}query-category/${id}/`, data);
  };

  deleteCategoryById = async (id: string): Promise<any> => {
    return await del(`${base}query-category/${id}/`);
  };

  getQueryMasters = async (
    page?: number,
    pageSize?: number,
    search?: string
  ): Promise<PaginatedResponse<QueryMaster>> => {
    let url = `${base}query-master/`;
    if (page) {
      url += `?page=${page}`;
    }
    if (pageSize) {
      url += `&page_size=${pageSize}`;
    }
    if (search) {
      url += `&search=${search}`;
    }
    return await get(url);
  };

  createQueryMaster = async (data: CreateQueryMasterPayload): Promise<any> => {
    return await post(`${base}query-master/`, data);
  };

  getQueryMasterById = async (id: string): Promise<any> => {
    return await get(`${base}query-master/${id}/`);
  };

  updateQueryMasterById = async (
    id: string,
    data: CreateQueryMasterPayload
  ): Promise<any> => {
    return await put(`${base}query-master/${id}/`, data);
  };

  deleteQueryMasterById = async (id: string): Promise<any> => {
    return await del(`${base}query-master/${id}/`);
  };

  getAdvancedQueryFields = async (
    page?: number,
    pageSize?: number,
    search?: string
  ): Promise<PaginatedResponse<AdvancedQueryField>> => {
    let url = `${base}advanced-query-fields/`;
    if (page) {
      url += `?page=${page}`;
    }
    if (pageSize) {
      url += `&page_size=${pageSize}`;
    }
    if (search) {
      url += `&search=${search}`;
    }
    return await get(url);
  };

  createAdvancedQueryField = async (
    data: CreateAdvancedQueryFieldPayload
  ): Promise<AdvancedQueryField> => {
    return await post(`${base}advanced-query-fields/`, data);
  };

  getAdvancedQueryFieldById = async (id: string): Promise<any> => {
    return await get(`${base}advanced-query-fields/${id}/`);
  };

  updateAdvancedQueryFieldById = async (
    id: string,
    data: CreateAdvancedQueryFieldPayload
  ): Promise<any> => {
    return await put(`${base}advanced-query-fields/${id}/`, data);
  };

  deleteAdvancedQueryFieldById = async (id: string): Promise<any> => {
    return await del(`${base}advanced-query-fields/${id}/`);
  };

  executeAdvancedQuery = async <T = any>(
    data: ExecuteAdvancedQueryPayload,
    page?: number,
    pageSize?: number
  ): Promise<ExecuteAdvancedQueryResponse<T>> => {
    let url = `${base}company-master/advanced-query/`;
    if (page) {
      url += `?page=${page}`;
    }
    if (pageSize) {
      url += `&page_size=${pageSize}`;
    }
    return await post(url, data);
  };

  saveUserQuery = async (data: SaveUserQueryPayload): Promise<UserQuery> => {
    return await post(`${base}user-query-master/`, data);
  };

  getUserQueryById = async (id: string): Promise<any> => {
    return await get(`${base}user-query-master/${id}/`);
  };

  updateUserQueryById = async (
    id: string,
    data: SaveUserQueryPayload
  ): Promise<any> => {
    return await put(`${base}user-query-master/${id}/`, data);
  };

  deleteUserQueryById = async (id: string): Promise<any> => {
    return await del(`${base}user-query-master/${id}/`);
  };

  getUserQueries = async (
    page?: number,
    pageSize?: number,
    search?: string
  ): Promise<PaginatedResponse<UserQuery>> => {
    let url = `${base}user-query-master/`;
    if (page) {
      url += `?page=${page}`;
    }
    if (pageSize) {
      url += `&page_size=${pageSize}`;
    }
    if (search) {
      url += `&search=${search}`;
    }
    return await get(url);
  };
}

export default new ScreenerService();
